<template>
    <div v-if="isOnlyContent">
        <div v-if="images" class="row">
            <template v-for="image in images">
                <div class="col-sm-6 col-md-4 col-lg-4">
                    <div class="c-image c-image--label mb-3">
                        <div class="c-image__inner">
                            <img :src="image.presigned_url" @click="openModal(image.presigned_url)">
                            <span v-if="image.flg_shared">共有済</span>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div v-if="Number( image.flg_shared ) < 1" class="text-center">
                                <b-button size="sm"
                                          class="mt-2"
                                          variant="yokumiru-blue"
                                          @click="updateFlgShared(image.id, 1)">
                                    {{ $locale.patient }}へ共有
                                </b-button>
                            </div>

                            <div v-else class="text-center">
                                <b-button size="sm"
                                          class="mt-2"
                                          variant="yokumiru-gray"
                                          @click="updateFlgShared(image.id, 0)">
                                    共有をやめる
                                </b-button>
                            </div>
                            <div class="text-center">
                                <b-button
                                    size="sm"
                                    class="mt-2 ml-2"
                                    variant="yokumiru-gray"
                                    :href="image.presigned_url"
                                    target="_blank"
                                    @click="validateUrlExpired(image.presigned_url, $event)">
                                    DL
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <div v-else class="card">
        <div class="card mb-3 mb-lg-0">
            <div class="card-header">
                <div class="d-flex align-items-center justify-content-between">
                    <div class="font-weight-bold">撮影画像</div>

                    <b-button @click="isShow = true"
                              size="sm"
                              variant="yokumiru-gray"
                              :class="{ 'd-none' : isShow }">開く</b-button>

                    <b-button @click="isShow = false"
                              size="sm"
                              variant="yokumiru-gray"
                              :class="{ 'd-none' : ! isShow }">閉じる</b-button>
                </div>
            </div>

            <div class="card-body mt-2"
                 :class="{ 'd-none' : ! isShow }">

                <div v-if="images">
                    <div class="row">
                        <template v-for="image in images">
                            <div class="col-sm-6 col-md-4 col-lg-4 mb-3">
                                <div class="c-image c-image--label">
                                    <div class="c-image__inner">
                                        <img :src="image.presigned_url" @click="openModal(image.presigned_url)"v>
                                        <span v-if="image.flg_shared">共有済</span>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center">
                                    <div v-if="Number( image.flg_shared ) < 1" class="text-center">
                                        <b-button size="sm"
                                                  class="mt-2"
                                                  variant="yokumiru-blue"
                                                  @click="updateFlgShared(image.id, 1)">
                                            {{ $locale.patient }}へ共有
                                        </b-button>
                                    </div>

                                    <div v-else class="text-center">
                                        <b-button size="sm"
                                                  class="mt-2"
                                                  variant="yokumiru-gray"
                                                  @click="updateFlgShared(image.id, 0)">
                                            共有をやめる
                                        </b-button>
                                    </div>
                                    <div class="text-center">
                                        <b-button
                                            size="sm"
                                            class="mt-2 ml-2"
                                            variant="yokumiru-gray"
                                            :href="image.presigned_url"
                                            target="_blank"
                                            @click="validateUrlExpired(image.presigned_url, $event)">
                                            DL
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from "moment-timezone"

    export default {
        props: [
            'data',
            'consultationId',
            'isOnlyContent',
        ],

        data: function() {
            return {
                isShow: true,
                images: null,
                componentCreatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            };
        },

        created: function() {
            if (this.data) {
                this.images = this.data
                this.isShow = this.images && this.images.length > 0
                bus.$emit('update-tab-css', 'image', this.isShow)
            }
            else if (this.consultationId) {
                this.fetchImages()
            }
        },

        mounted: function () {
            window.Echo.private(`consultation.${this.consultationId}`)
                .listen('ConsultationImageStored', () => {
                    this.fetchImages()
                })
                .listen('ConsultationImageShared', () => {
                    this.fetchImages()
                })
        },

        methods: {
            /**
             * 撮影画像一覧
             */
            fetchImages: function () {
                axios.get(`${constants.admin.consultations.endpoint.base}/${this.consultationId}/images`)
                    .then(({data}) => {
                        this.images = data
                        this.isShow = this.images && this.images.length > 0
                        bus.$emit('update-tab-css', 'image', this.isShow)
                    })
            },

            /**
             * 共有設定の更新
             *
             * @param {number} id
             * @param {number} flg
             */
            updateFlgShared: function ( id, flg ) {

                const data = { flg_shared: flg };

                axios.put( `${constants.admin.consultations.endpoint.images}/${id}`, data )
                    .then( () => {

                        const idx = this.images.findIndex( ( image ) => {
                            return Number( image.id ) === Number( id );
                        } );

                        this.images[ idx ].flg_shared = flg;
                    } );
            },

            openModal: function(ref){
                bus.$emit( 'open-modal-image', ref );
            },

            /**
             * DLリンクの有効期限バリデーション
             *
             * @param {string} url
             * @param {object} event
             */
            validateUrlExpired: function (url, event) {
                const expiredSec = Number(url.replace(/^.+X-Amz-Expires=([0-9]+).+$/u, '$1'))
                const expiredAt = moment(this.componentCreatedAt).add(expiredSec, 'seconds')
                const expired = moment().isSameOrAfter(expiredAt)

                if (expired) {
                    bus.$emit('alert-warning', 'ダウンロードの有効期限が切れています。ブラウザを再読み込みしてください。')
                    event.preventDefault()
                }
            },
        },
    }
</script>

